<template>
  <div class="sl-wrapper" :class="wrapperClasses">
    <div class="level" :style="levelStyle"></div>
    <div class="mark-wrapper">
      <div class="mark left"></div>
      <div class="actual">{{ level }}°</div>
      <div class="mark right"></div>
    </div>
  </div>
</template>

<script>
const TO_PASS = 90;
const MAX = 180;

export default {
  name: 'SpiritLevel',
  props: {
    level: {
      type: Number,
      default: 0,
    },
    passed: Boolean,
  },
  computed: {
    levelStyle() {
      return { height: `${(this.level / MAX) * 100}%` };
    },
    delta() {
      return Math.abs(TO_PASS - this.level);
    },
    passing() {
      return this.delta <= 2;
    },
    over() {
      return this.level > TO_PASS;
    },
    under() {
      return this.level < TO_PASS;
    },
    wrapperClasses() {
      const { passing, over, under } = this;
      return { passing, over, under };
    },
  },
  watch: {
    passing: {
      handler(nv) {
        this.$emit('passed', nv);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.sl-wrapper {
  @apply bg-black w-full flex-1 relative flex justify-center items-center;
  &.passing {
    .level {
      background: linear-gradient(90deg, #540DEB 11.03%, #2245FF 83.45%);
    }
  }
  &.over {
    .mark {
      @apply bg-black;
    }
    .actual {
      color: black;
      text-shadow: 2px 1px 3px white;
    }
  }
  &.under,
  &.passing {
    .mark {
      @apply bg-white;
    }
    .actual {
      color: white;
    }
  }
  &.under {
    .actual {
      text-shadow: 2px 1px 3px black;
    }
  }
}
.level {
  @apply absolute bg-white w-full bottom-0;
}
.mark-wrapper {
  @apply w-full flex items-center justify-between z-10;
}
.mark {
  width: 60px;
  height: 3px;
}
.actual {
  @apply font-light;
  font-size: 60px;
}
</style>
